export const addHeaders=(value:any):any=>
	localStorage.getItem('token') ?
		{...value,'access-token':localStorage.getItem('token')}
		:
		value;

